import Vue from 'vue'
import _get from 'lodash/get'
import wysiwyg from 'vue-wysiwyg'

import App from './views/App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import './plugins/vee-validate'
import { createProvider } from './vue-apollo'
import { currentSite, i18n } from './extend'
import * as CONST from '@/const/shared'

const ignoreWarnMessage = 'The .native modifier for v-on is only valid on components but it was used on <div>.'
// eslint-disable-next-line no-unused-vars
Vue.config.warnHandler = function(msg, vm, trace) {
  // `trace` is the component hierarchy trace
  if (msg === ignoreWarnMessage) {
    console.warn(msg)
    msg = null
    vm = null
    trace = null
  }
}

Vue.use(wysiwyg, {})

Vue.config.productionTip = false
Vue.prototype.$log = console.log
Vue.prototype.$const = CONST
Vue.prototype.$get = _get

Object.defineProperty(Vue.prototype, '$site', {
  enumerable: true,
  get: currentSite
})

new Vue({
  router,
  store,
  vuetify,
  apolloProvider: createProvider(),
  i18n,
  render: h => h(App)
}).$mount('#app')
